import { createSlice } from "@reduxjs/toolkit";
// import jwt_decode from "jwt-decode";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    isAuthenticated: false,
    user: {
      email: "",
      name: "",
      picture: "",
      isAdmin: false,
      role: null,
      companyId: null,
    },
  },
  reducers: {
    setCredentials: (state, action) => {
      const { email, isAdmin, token, name, role, companyId } = action.payload;

      state.user.email = email;
      state.user.isAdmin = isAdmin;
      state.user.name = name;
      state.user.role = role;
      state.user.companyId = companyId || null;
      state.token = token;
      state.isAuthenticated = true;
    },
    logOut: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = {
        email: "",
        name: "",
        picture: "",
        isAdmin: false,
        role: null,
        companyId: null,
      };
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const isAuthenticated = (state) => state.isAuthenticated;
export const selectCurrentToken = (state) => state.auth.token;
